<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import ZjzqrBrowse from "./ZjzqrBrowse";
import ZjzqrEdit from "./ZjzqrEdit";
import ZjzqrView from "./ZjzqrView";
export default {
    name: "Zjzqr",
    components: { ZjzqrBrowse, ZjzqrEdit, ZjzqrView },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showView: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "ZjzqrEdit";
            } else if (this.editProps.showView === true) {
                return "ZjzqrView";
            } else {
                return "ZjzqrBrowse";
            }
        }
    }
};
</script>
